module.exports = __webpack_public_path__ + "static/media/tombaSchiratti.e1ec9225.jpg";